import React from "react";

import {
  useDataGrid,
  DataGrid,
  GridColumns,
  DeleteButton,
  List,
  Stack,
  esES,
} from "@pankod/refine-mui";
import { IExcess } from "interfaces";

export const ExcessList: React.FC = () => {
  const { dataGridProps } = useDataGrid<IExcess>({
    metaData: {
      populate: ["employee", "order"],
    },
  });

  const columns = React.useMemo<GridColumns<IExcess>>(
    () => [
      {
        field: "order",
        headerName: "Orden",
        flex: 1,
        valueGetter: (params) => params?.row?.order?.order || "",
      },
      {
        field: "employee",
        headerName: "Empleado",
        flex: 1,
        valueGetter: (params) => params?.row?.employee?.name || "",
      },
      { field: "material", headerName: "Material", flex: 1 },
      { field: "weight", headerName: "Peso sobrante", flex: 1 },
      { field: "type", headerName: "Proceso", flex: 1 },
      {
        headerName: "Acciones",
        headerAlign: "center",
        field: "actions",
        minWidth: 180,
        align: "center",
        flex: 1,
        renderCell: function render(params) {
          return (
            <Stack direction="row" spacing={1}>
              <DeleteButton
                size="small"
                hideText
                recordItemId={params.row.id}
              />
            </Stack>
          );
        },
      },
    ],
    []
  );

  return (
    <List>
      <DataGrid
        {...dataGridProps}
        autoHeight
        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
      />
    </List>
  );
};
